import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LocalLoader from "@/components/ui/loaders/LocalLoader.vue";

interface Props {
  position?: "fixed" | "absolute";
  backdropFilter?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalLoader',
  props: {
    position: { default: "fixed" },
    backdropFilter: { default: "2" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["global-loader", `global-loader--${props.position}`]),
    style: _normalizeStyle({ backdropFilter: `blur(${props.backdropFilter}px)` })
  }, [
    _createVNode(LocalLoader)
  ], 6))
}
}

})